import React from "react";
import styled from "styled-components";
import { Row, Column, Text } from "../theme/index";

const Arrow = styled.div`
  width: 0;
  height: 0;
  border-right: 7px solid transparent;
  border-left: 7px solid transparent;
  border-bottom: 7px solid #fff;
  margin: 0 0 0 5em;
  right: 2.8em;
  top: 4.7em;
  position: absolute;
  z-index: 5;
`;

const Menu = styled.div`
  background: #fff;
  border-radius: 3px;
  width: 125px;
  height: 180px;
  position: absolute;
  right: 1.4em;
  top: 5.1em;
  display: flex;
  flex-direction: column;
  z-index: 2;
  box-shadow: 0 2px 8px 0 rgba(34, 34, 34, 0.5);
`;

const StyledRow = styled(Row)`
  cursor: pointer;
  align-items: center;
  justify-content: center;
  &:hover {
    background-color: #f7f7f7;
  }
`;

const StyledText = styled(Text)`
  font-size: 0.9em;
  color: #2b2b2b;
  line-height: 1em;
  margin: 0.75em 0;
`;

export default function DropdownModal({ display = false, options = [{}] }) {
  return (
    <div
      style={{
        display: display ? "block" : "none"
      }}
    >
      <Arrow />
      <Menu>
        <Column padding=".5em 0">
          {options.map((key, index) => {
            return (
              <StyledRow
                key={index}
                onClick={() => key.onClick && key.onClick(key)}
              >
                <StyledText>{key.label}</StyledText>
              </StyledRow>
            );
          })}
        </Column>
      </Menu>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/shared/DropdownModal.jsx